<template>
  <div
    class="relative w-full bg-black group select-none aspect-video"
    :class="$root.isPopup ? 'h-full' : ''"
    @mouseover="btnHide = true"
    @mouseleave="btnHide = false"
  >
    <!--
      RELOAD SVG
    -->

    <svg
      class="m-auto absolute animate-spin opacity-30 w-[76px]"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 95.979 96"
      style="
        fill: #454545;
        filter: drop-shadow(0px 0px 15px rgb(255 255 255 / 0.6));
        top: calc(50% - 38px);
        left: calc(50% - 38px);
      "
    >
      <path
        d="M2,50A48,48,0,0,1,16.07,16.07L5.61,5.61A2.11,2.11,0,0,1,7.1,2H35a3,3,0,0,1,3,3V32.9a2.11,2.11,0,0,1-3.61,1.49l-9.84-9.84A36,36,0,0,0,50,86V98A48.05,48.05,0,0,1,2,50ZM50,2V14A36,36,0,0,1,75.45,75.45l-9.74-9.74A2.17,2.17,0,0,0,62,67.25V95a3,3,0,0,0,3,3H92.75a2.17,2.17,0,0,0,1.54-3.71L83.93,83.93A48,48,0,0,0,50,2Z"
        transform="translate(-2 -2)"
      />
    </svg>

    <!--
      VIDEO CONTAINER
    -->

    <div class="absolute w-full h-full" style="padding: 20px 0px 12px">
      <video
        ref="video_container"
        class="w-full h-full"
        preload="none"
        controlslist="noremoteplayback nodownload"
        autoplay
        playsinline
        muted
      ></video>

      <message
        class="absolute resize text-center w-full text-xs"
        style="top: calc(50% + 50px)"
      >
        <p ref="message_container"></p>
        <p class="mt-1" v-if="!video.publish && !video.isWebcam">
          {{
            $e(
              "La vidéo ne semble pas publiée ; vérifiez si l'appareil actif ; si un autre flux est actif, changer de caméra, ou rafrachissez le flux."
            )
          }}
        </p>
      </message>
      <message> </message>
    </div>

    <!--
      UP
    -->

    <div
      class="absolute flex top-[2px] z-50 w-full px-[6px] px-0 left-0 h-[14px]"
      :class="{ hidden: hide }"
    >
      <!-- Name -->
      <div class="w-full flex items-center text-xs">
        #{{ config.drone.id }} - {{ config.drone.name }}
      </div>

      <!-- Reload -->
      <div
        @click.stop.prevent="reload()"
        class="flex justify-end !cursor-pointer hover:text-flyingeye-light transition-all items-center w-full overflow-x-clip ml-3"
      >
        <svg
          class="w-[12px] fill-current"
          :class="video?.relaod ? 'animate-spin' : ''"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 95.979 96"
        >
          <path
            d="M2,50A48,48,0,0,1,16.07,16.07L5.61,5.61A2.11,2.11,0,0,1,7.1,2H35a3,3,0,0,1,3,3V32.9a2.11,2.11,0,0,1-3.61,1.49l-9.84-9.84A36,36,0,0,0,50,86V98A48.05,48.05,0,0,1,2,50ZM50,2V14A36,36,0,0,1,75.45,75.45l-9.74-9.74A2.17,2.17,0,0,0,62,67.25V95a3,3,0,0,0,3,3H92.75a2.17,2.17,0,0,0,1.54-3.71L83.93,83.93A48,48,0,0,0,50,2Z"
            transform="translate(-2 -2)"
          />
        </svg>
      </div>

      <!-- QRCode -->
      <div
        class="ml-3 cursor-pointer hover:text-flyingeye-light transition-all"
        v-if="!$root.isPopup"
        @click="
          config.qrCodeOpen = config.qrCodeOpen == false ? video?.url : false
        "
        :class="{ 'text-flyingeye-light': config.qrCodeOpen != false }"
      >
        <SVG name="qrcode" css="h-full fill-current"></SVG>
      </div>

      <!-- Setting -->
      <div
        class="ml-3 cursor-pointer hover:text-flyingeye-light transition-all"
        @click="config.settingOpen = !config.settingOpen"
        :class="{ 'text-flyingeye-light': config.settingOpen }"
        v-if="
          config.camera.payloadAsSelected && this.config.isDock && !this.isPopup
        "
      >
        <svg
          class="h-full fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 388.16 296.6"
        >
          <path
            d="M369.77,236.7h-225.24c-9.63-19.5-32.9-28.41-53.25-19.91-9.38,3.97-16.75,11.14-21.08,19.91H18.39c-10.15,0-18.39,8.23-18.39,18.39s8.23,18.39,18.39,18.39h51.85c6.79,13.7,20.9,23.12,37.22,23.13,5.55.01,11.05-1.1,16.17-3.26,9.51-4.06,16.71-11.26,20.95-19.87h225.2c10.15,0,18.39-8.23,18.39-18.39s-8.23-18.39-18.39-18.39ZM119.77,255.06c0,6.8-5.51,12.32-12.32,12.32s-12.32-5.51-12.32-12.32,5.51-12.32,12.32-12.32,12.32,5.51,12.32,12.32Z"
          />
          <path
            d="M369.77,130.18h-36.86c-9.63-19.5-32.9-28.41-53.25-19.91-9.38,3.97-16.75,11.14-21.07,19.91H18.39c-10.15,0-18.39,8.23-18.39,18.39s8.23,18.39,18.39,18.39h240.23c6.79,13.7,20.9,23.12,37.22,23.13,5.55.01,11.05-1.1,16.17-3.26,9.51-4.06,16.71-11.26,20.95-19.87h36.82c10.15,0,18.39-8.23,18.39-18.39s-8.23-18.39-18.39-18.39ZM308.15,148.56c0,6.8-5.51,12.32-12.32,12.32s-12.32-5.51-12.32-12.32,5.51-12.32,12.32-12.32,12.32,5.51,12.32,12.32Z"
          />
          <path
            d="M369.77,23.67h-150.92c-9.46-19.88-32.98-29.03-53.52-20.45-9.57,4.05-17.06,11.43-21.34,20.45H18.39C8.23,23.67,0,31.91,0,42.06s8.23,18.39,18.39,18.39h126.18c6.89,13.4,20.84,22.58,36.94,22.59,5.55.01,11.05-1.1,16.17-3.26,9.31-3.98,16.41-10.96,20.68-19.33h151.42c10.15,0,18.39-8.23,18.39-18.39s-8.23-18.39-18.39-18.39ZM193.76,41.52c0,6.8-5.51,12.32-12.32,12.32s-12.32-5.51-12.32-12.32,5.51-12.32,12.32-12.32,12.32,5.51,12.32,12.32Z"
          />
        </svg>
      </div>

      <!-- Popup
      -->
      <div
        @click.stop.prevent="openPopup()"
        class="ml-3 cursor-pointer hover:text-flyingeye-light transition-all"
      >
        <svg
          class="fill-current h-full"
          v-if="!$root.isPopup"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 18 18"
        >
          <path
            d="M15.75,18h-4.5V15.75h4.5v-4.5H18V18ZM2.25,18H0V11.25H2.25v4.5h4.5V18ZM15.75,6.75V2.25h-4.5V0H18V6.75ZM0,6.75V0H6.75V2.25H2.25v4.5Z"
          />
        </svg>
        <svg
          class="fill-current h-full"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 18 18"
          v-else
        >
          <path
            d="M11.25,18V11.25H18V13.5H13.5V18ZM4.5,18V13.5H0V11.25H6.75V18Zm9-11.25H11.25V0H13.5V4.5H18V6.75Zm-9,0H0V4.5H4.5V0H6.75V6.75Z"
          />
        </svg>
      </div>

      <!-- Close -->
      <div @click.stop.prevent="closeVideo()" class="ml-3">
        <svg
          viewBox="0 0 89 95"
          fill="none"
          class="fill-current h-full fill-current hover:fill-flyingeye-light transition-all"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M44.4 44.6C46.3 44.6 47.8 43.1 47.8 41.2V3.4C47.8 1.5 46.3 0 44.4 0C42.5 0 41 1.5 41 3.4V41.2C41 43.1 42.5 44.6 44.4 44.6Z"
          />
          <path
            d="M63.6 10.7C61.9 9.89999 59.9 10.6 59 12.3C58.2 14 58.9 16 60.6 16.9C73.5 23.1 81.8 36.3 81.8 50.7C81.8 71.4 65 88.2 44.3 88.2C23.6 88.2 6.9 71.3 6.9 50.7C6.9 36.4 15.2 23.1 28.1 16.9C29.8 16.1 30.5 14 29.7 12.3C28.9 10.6 26.8 9.89999 25.1 10.7C9.9 18 0 33.7 0 50.6C0 75.1 19.9 94.9 44.3 94.9C68.7 94.9 88.6 75 88.6 50.6C88.7 33.7 78.9 18.1 63.6 10.7Z"
          />
        </svg>
      </div>
    </div>

    <!--
      CAMERA
    -->
    <div class="w-full h-full" :class="{ hidden: hide }">
      <Camera
        :config="config"
        :video="video"
        v-if="config.isDock && !video?.cameradock"
      />
    </div>

    <!--
      BTN HIDE
    -->

    <div
      class="absolute bottom-[5px] right-[5px] w-[30px] p-[3px] bg-g0-dark/70 hidden group-hover:flex z-50 hover:!opacity-100 delay-1000 duration-1000 transition-all cursor-pointer"
      @click="hide = !hide"
      :class="{ 'fade-out-bck': btnHide }"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 147.8 107.38">
        <path
          d="M147.24,51.54c-14.9-26.5-42.93-42.91-73.33-42.92-30.4.02-58.43,16.42-73.34,42.92-.37.65-.56,1.39-.56,2.14.01.75.2,1.48.56,2.14,22.75,40.5,74.04,54.89,114.54,32.14,13.46-7.56,24.58-18.68,32.14-32.14.75-1.33.75-2.95,0-4.28ZM34.89,79.19c-10.44-6.31-19.19-15.07-25.51-25.51C23.05,31.1,47.52,17.31,73.91,17.3c26.39,0,50.86,13.8,64.51,36.38-21.54,35.63-67.9,47.05-103.53,25.51Z"
          style="fill: #fff; fill-rule: evenodd; stroke-width: 0px"
        />
        <path
          d="M91.62,45.91c-5.47,0-9.91-4.44-9.91-9.91,0-2.52.95-4.81,2.5-6.56-3.16-1.35-6.65-2.1-10.3-2.11-14.56,0-26.36,11.79-26.37,26.35s11.79,26.36,26.35,26.37c14.56,0,26.36-11.79,26.37-26.35h0c0-3.65-.75-7.12-2.09-10.27-1.75,1.54-4.03,2.48-6.55,2.48Z"
          style="fill: #fff; fill-rule: evenodd; stroke-width: 0px"
        />
        <path
          d="M130.7,2.81l6.88,8.97L17.1,104.57l-6.88-8.97L130.7,2.81Z"
          :class="{ hidden: !hide }"
          style="
            fill: #fff;
            stroke: #000;
            stroke-miterlimit: 10;
            stroke-width: 4px;
          "
        />
      </svg>
    </div>
  </div>

  <template
    v-if="
      config.settingOpen &&
      this.config.isDock &&
      !video.cameradock &&
      !$root.isPopup
    "
  >
    <Setting :config="config" />
  </template>
</template>

<script>
import { ref } from "vue";

import SVG from "@/partials/SVG.vue";

import Camera from "@/partials/Video/Camera/Camera.vue";
import Setting from "@/partials/Video/Camera/Setting.vue";

export default {
  name: "Video",

  props: {
    config: Object,
    video: Object,
  },

  components: {
    SVG,
    Camera,
    Setting,
  },

  setup() {
    return {
      video_container: ref(null),
      message_container: ref(null),
      webrtcPlayer: ref(null),
      // ----------------
      hide: ref(false),
      btnHide: ref(false),
    };
  },

  mounted() {
    this.close();

    this.webrtcPlayer = new WebRTCStreamer(
      this.video_container,
      this.message_container,
      this.video.url,
      this
    );

    this.webrtcPlayer.init();
  },

  beforeUnmount() {
    this.close();
  },

  methods: {
    close() {
      this?.webrtcPlayer?.pc?.close();
      clearTimeout(this?.webrtcPlayer?.restartTimeout);
    },

    closeVideo() {
      this.config.methods.CloseVideo(this.video, () => {
        this.close();
      });
    },

    reload() {
      this.video.relaod = true;
      this.config.methods.ReloadVideo(this.video);
    },

    openPopup() {
      window.open(this.video.url, "_blank");
    },
  },

  computed: {},
};
</script>
